import React from 'react';
import {PropTypes} from 'prop-types';
import LoadingOverlay from '@homeaway/react-loading-overlay/lib/esm/LoadingOverlay';
import Notifications from '../Notifications/Notifications.react';
import OnboardingGuide from '../OnboardingGuide/OnboardingGuide.react';
import TourPanel from '../TourPanel/TourPanel.react';
import './Overlay.less';
import Media from 'react-media';
import Viewport from '../Viewport/Viewport.react';
import AbacusContext from '../../../../Contexts/Abacus/Context';
import LocaleProvider from '../../../../Contexts/Locale/Provider.react';
import DirectNavigationMenu from '../DirectNavigationMenu/DirectNavigationMenu.react';
import DirectNavigationModel from '../DirectNavigationMenu/DirectNavigationModel';
import LocaleContext from '../../../../Contexts/Locale/Context';
import TourContext from '../../../../Contexts/Tour/Context';
import InitialImageContext from '../../../../Contexts/InitialImage/Context';
import NavigationContext from '../../../../Contexts/Navigation/Context';
import Commands from '../Commands/Commands.react';

// TODO: Rename to "TourClient"
class Overlay extends React.Component {
    static propTypes = {
        overlay: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        tour: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        params: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
        onClickHelp: PropTypes.func.isRequired,
        onOnboardingDone: PropTypes.func.isRequired,
        onOnboardingPage: PropTypes.func.isRequired,
        onExit: PropTypes.func.isRequired,
        /**
         * onSphereSelected takes a string, sphereId
         */
        onSphereSelected: PropTypes.func,
        onSelectNavSpace: PropTypes.func,
        onNavMenuOpen: PropTypes.func,
        onNavMenuClose: PropTypes.func,
    };

    constructor(props) {
        super(props);
    }

    componentDidMount(): void {}

    _getOldInterface(matches, props) {
        return (
            <React.Fragment>
                <TourPanel
                    onClickHelp={props.onClickHelp}
                    overlay={props.overlay}
                    mediaMatches={matches}
                    onSelectGroup={props.onSelectGroup}
                    tour={props.tour}
                />
                <TourContext.Consumer>
                    {(tourData) =>
                        tourData && (
                            <InitialImageContext.Consumer>
                                {(image) => (
                                    <Viewport
                                        viewport={props.overlay.get('viewport')}
                                        bundle={props.params.bundle}
                                        options={props.params.options}
                                        params={props.params}
                                        tourData={tourData}
                                        initialImage={image}
                                    />
                                )}
                            </InitialImageContext.Consumer>
                        )
                    }
                </TourContext.Consumer>
            </React.Fragment>
        );
    }

    _getDirectNavInterface(matches) {
        let showHelpButton = !this.props.overlay.get('showOnboardingGuide');
        let props = this.props;

        return (
            <React.Fragment>
                <TourContext.Consumer>
                    {(tourData) =>
                        tourData ? (
                            <NavigationContext.Consumer>
                                {(navigation) => (
                                    <React.Fragment>
                                        <InitialImageContext.Consumer>
                                            {(image) => (
                                                <Viewport
                                                    viewport={props.overlay.get('viewport')}
                                                    bundle={props.params.bundle}
                                                    options={props.params.options}
                                                    params={props.params}
                                                    tourData={tourData}
                                                    initialImage={image}
                                                    navigation={navigation}
                                                />
                                            )}
                                        </InitialImageContext.Consumer>
                                        <LocaleContext.Consumer>
                                            {(getTranslation) => (
                                                <AbacusContext.Consumer>
                                                    {(experiments) => {
                                                        return this._getResolvedDirectNavigationMenu(
                                                            navigation,
                                                            experiments,
                                                            tourData,
                                                            getTranslation,
                                                            matches,
                                                            props
                                                        );
                                                    }}
                                                </AbacusContext.Consumer>
                                            )}
                                        </LocaleContext.Consumer>
                                    </React.Fragment>
                                )}
                            </NavigationContext.Consumer>
                        ) : null
                    }
                </TourContext.Consumer>
                <Commands
                    disableHelp={!showHelpButton}
                    onClickHelp={this.props.onClickHelp}
                    onExit={this.props.onExit}
                    size={matches.screenXsMax ? 'sm' : null}
                />
            </React.Fragment>
        );
    }

    _isMultiSpaceOrGroup(navigation, groups) {
        // returns true is there is at least 2 groups OR 1 space
        return (
            (DirectNavigationModel.doesNavigationHaveSpaces(navigation) &&
                navigation.spaces.length > 0) ||
            (DirectNavigationModel.doesNavigationHaveGroups(navigation) &&
                navigation.groups.length > 1) ||
            groups.length > 1
        );
    }

    _shouldReturnNullDirectNavigationMenu(navigation, tourData) {
        return !this._isMultiSpaceOrGroup(navigation, tourData.groups);
    }

    _shouldReturnDirectNavigationMenuWithSpaces(navigation) {
        return (
            this._isLabeledWithDirectNavigation(navigation) &&
            DirectNavigationModel.doesNavigationHaveGroups(navigation)
        );
    }

    _isLabeledWithDirectNavigation(navigation) {
        return (
            DirectNavigationModel.doesNavigationHaveGroupsAndSpaces(navigation) &&
            navigation.groups.length > 0 &&
            navigation.spaces.length > 0
        );
    }

    _getResolvedDirectNavigationMenu(
        navigation,
        experiments,
        tourData,
        getTranslation,
        matches,
        props
    ) {
        const shouldReturnNullDirectNavigationMenu = this._shouldReturnNullDirectNavigationMenu(
            navigation,
            tourData
        );
        const shouldReturnDirectNavigationMenuWithSpaces = this._shouldReturnDirectNavigationMenuWithSpaces(
            navigation
        );

        let resolvedDirectNavigationMenu;

        if (shouldReturnNullDirectNavigationMenu) {
            resolvedDirectNavigationMenu = null;
        } else if (shouldReturnDirectNavigationMenuWithSpaces) {
            resolvedDirectNavigationMenu = (
                <DirectNavigationMenu
                    mediaMatches={matches}
                    navigation={navigation}
                    sphereId={props.tour.get('currentSphereId')}
                    onSelectNavSpace={props.onSelectNavSpace}
                    onOpen={props.onNavMenuOpen}
                    onClose={props.onNavMenuClose}
                    hotspotsHidden={props.params.hideHotspots}
                    useMediaGateway={props.params.useMediaGateway}
                />
            );
        } else {
            // should return navigation with groups only in all other cases
            resolvedDirectNavigationMenu = (
                <DirectNavigationMenu
                    mediaMatches={matches}
                    navigation={DirectNavigationModel.getNavigationFromGroups(
                        tourData.groups,
                        tourData,
                        getTranslation
                    )}
                    sphereId={props.tour.get('currentSphereId')}
                    onSelectNavSpace={props.onSphereSelected}
                    onOpen={props.onNavMenuOpen}
                    onClose={props.onNavMenuClose}
                    useMediaGateway={props.params.useMediaGateway}
                />
            );
        }

        return resolvedDirectNavigationMenu;
    }

    render() {
        let props = this.props;
        let params = props.params;
        let queries = {
            screenXsMax: '(max-width: 767px)',
        };
        return (
            <LocaleProvider locale={params.locale}>
                <div className="OverlayEventLayer" onKeyPress={this._onKeyPress}>
                    <Media queries={queries}>
                        {(matches) => (
                            <React.Fragment>
                                {this._getDirectNavInterface(matches)}
                                {props.overlay.get('showOnboardingGuide') && (
                                    <OnboardingGuide
                                        pageIndex={props.overlay.get('onboardingGuideIndex')}
                                        onDone={props.onOnboardingDone}
                                        onPage={props.onOnboardingPage}
                                        pages={
                                            params.hideHotspots
                                                ? OnboardingGuide.noHotspotProps.pages
                                                : OnboardingGuide.defaultProps.pages
                                        }
                                    />
                                )}
                                <LoadingOverlay loading={props.overlay.get('showLoadingOverlay')} />
                                <Notifications notifications={props.overlay.get('notifications')} />
                            </React.Fragment>
                        )}
                    </Media>
                </div>
            </LocaleProvider>
        );
    }
}

export default Overlay;
